// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import 'lib-flexible';
import axios from 'axios';
import axconf from './conf/axios';
import jwtDecode from './conf/jwt-decode';
import MintUI from 'mint-ui';
import store from './store';
import echarts from 'echarts';
import echartsTheme from './conf/echart-theme.json';
import VeeValidate from 'vee-validate';
import topNav from './components/common/topNav';
import datepik from './components/common/datepik';
import i18n from '@/locale';
import 'normalize.css';
import 'animate.css';
import './assets/css/base.css';
import './assets/css/mint-ui-style.css';
import './assets/css/mobileOrdering.less';
import '../static/fonts/iconfont.css';
// import VConsole from 'vconsole';
// let vConsole = new VConsole() // 初始化
import * as dd from 'dingtalk-jsapi';
import SignCanvas from "sign-canvas";

window.dd = dd
Vue.prototype.$isDingTalk = dd.env && (dd.env.platform != 'notInDingTalk')
Vue.prototype.$isLD = false // 绿云钉
window.$isLD = false // 绿云钉 改了 ajax地址
window.$isLDTest = false // 绿云钉测试环境，改了cropId 和ajax地址


// 王万鹏测试用
// Vue.prototype.$corpId = 'ding1a17e1ca33c448d7f2c783f7214b6d69'
// Vue.prototype.$agentId = '1318170237'
// 正式的 //////////////////
// Vue.prototype.$corpId = 'dingf9462055bfc50e6935c2f4657eb6378f'
// Vue.prototype.$agentId = '328293258'


// 中南集团钉钉，找彭六七
Vue.prototype.$corpId = 'dingd0e8224677b003d424f2f5cc6abecb85'
Vue.prototype.$agentId = '2574867464'

// 明宇钉钉
// Vue.prototype.$corpId = 'dingccc2f9387a4742b535c2f4657eb6378f'
// Vue.prototype.$agentId = '1350908740'

// 辉辉:
//   AgentId：328293258
// 服务器出口IP：123.206.127.203
// AppKey：dingjnfqndkjuggmypp3
// AppSecret：tYcPOrG6cFQxIxBCvQx7GJJgoxSb8_Ojm4YEA3mFM_VgOuCAUpvG792_ZdbgKmdZ
//
// 辉辉:
//   CorpId:dingf9462055bfc50e6935c2f4657eb6378f

// 测试 ////////////
// Vue.prototype.$corpId = "ding458a3374c7d78a49"
// Vue.prototype.$agentId = "327208473"

import {
  MessageBox,
  Toast
} from 'mint-ui';
import userLocal from './conf/userLocal'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

Vue.use(SignCanvas);
Vue.use(VXETable)
// 给 vue 实例挂载全局窗口对象，属性名称随意定义，例如：$XModal
Vue.prototype.$modal = VXETable.modal

Vue.config.productionTip = false;
Vue.use(MintUI);
Vue.component('topNav', topNav);
Vue.component('datepik', datepik);
Vue.prototype.$userLocal = userLocal

axconf(axios);
Vue.prototype.$http = axios;
//版本号
Vue.prototype.pversion = 'V3.7.5';  // 锦江永远是3.6.2了，他们私服部署都不确定在不在用了
Vue.prototype.$isApp = window.navigator.userAgent.indexOf('Html5Plus') > 0;
//Mihotel特有功能标志
Vue.prototype.$isMihotel = true; // 是标准版, 明宇浩谷这里要改成false
Vue.prototype.$bookNew = window.$isLD; // 预定逻辑，绿云钉和标准版要改为true, 其他版本都是 false

Vue.prototype.$logo = 'my.png'; // "my.png，hotelGo.png
Vue.prototype.$posModel = 'pos'; // 手机点餐逻辑


Vue.use(VeeValidate);


// 本地存储判断是否当前酒店是opera
Vue.prototype.$setIsOpera = () => {
  localStorage.setItem('isOperaHotel', 'yes')
}
Vue.prototype.$setIsNotOpera = () => {
  localStorage.setItem('isOperaHotel', 'no')
}
Vue.prototype.$getIsOpera = () => {
  let temp = localStorage.getItem('isOperaHotel') || ''
  return temp == 'yes'
}

// 手机点餐要用这个值
Vue.prototype.$getMagicNo = function () {
  // return window.plus ? plus.device.uuid : '1234567899'
  return localStorage.getItem('hbuilderXNewUUID') || ''
}

Vue.prototype.confirm2 = function (msg, f) {
  MessageBox({
    message: msg,
    title: '',
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: this.$t('MessageBox_confirmButtonText'),
    cancelButtonText: this.$t('MessageBox_cancelButtonText')
  })
    .then(action => {
      if (action == 'confirm') {
        f();
      }
    })
    .catch(action => {
    });
}
Vue.prototype.msg2 = function (msg) {
  Toast({
    message: msg,
    position: 'bottom',
    duration: 3000
  });
  return false;
}
Vue.prototype.parseQueryString = function (url) {
  let arr = url.split('&');   //先通过？分解得到？后面的所需字符串，再将其通过&分解开存放在数组里
  let obj = {};
  for (let i of arr) {
    obj[i.split('=')[0]] = i.split('=')[1];  //对数组每项用=分解开，=前为对象属性名，=后为属性值
  }
  return obj;
}
Vue.prototype.wakeUpJingJiangApp = function (actionType) {
  if (window.plus) {
    let eventName = actionType == 'readIdCard' ? 'readIdCard' : 'make'

    let objStr = localStorage.getItem('JingJiangSetting') || "{}"
    let obj = JSON.parse(objStr)
    if (eventName == 'make' && !obj.autoWakeUpApp) {
      return
    }

    if (plus.os.name == 'Android') {
      plus.runtime.launchApplication({
        pname: 'com.xl.jjbreakfast', // 锦江app
        action: eventName,
        // pname: 'com.eg.android.AlipayGphone' // 支付宝
        extra: {'Event': eventName}
      }, function (e) {
        Toast({
          message: '程序开启失败,请检查是否安装锦江移动前台app',
          position: 'bottom',
          duration: 3000
        });
        return false;
      });
    }
  }
}

function wakeUpJingJiangAppPrint(path) {
  if (window.plus) {
    // alert('pdf地址：' + path)
    // EventName=Print&FilePath=/path/to/the/printed/file.pdf
    let eventName = 'Print'
    if (plus.os.name == 'Android') {
      plus.runtime.launchApplication({
        pname: 'com.xl.jjbreakfast', // 锦江app
        action: eventName,
        // pname: 'com.eg.android.AlipayGphone' // 支付宝
        extra: {
          'EventName': eventName,
          // 'FilePath': path,
          'PdfBase64': path
        }
      }, function (e) {
        Toast({
          message: '程序开启失败,请检查是否安装锦江移动前台app',
          position: 'bottom',
          duration: 3000
        });
        return false;
      });
    }
  }
}

Vue.prototype.wakeUpJingJiangAppPrint = wakeUpJingJiangAppPrint
Vue.prototype.error2 = function (msg) {
  MessageBox.alert(msg);
}
Vue.prototype.$getLanguage = function () {
  return localStorage.language || 'zh_CN';
}
Vue.prototype.downloadPdf = function (url) {
  const self = this
  // let url = 'https://online.fallingflowers.top:7443/test.pdf'
  Toast({
    message: '开始下载',
    position: 'bottom',
    duration: 3000
  });
  var dtask = plus.downloader.createDownload(url, {}, function (d, status) {
    if (status == 200) { // 下载成功
      Toast({
        message: 'pdf下载成功',
        position: 'bottom',
        duration: 3000
      });
      var path = d.filename;
      var fileSaveUrl = plus.io.convertLocalFileSystemURL(path);
      // plus.runtime.openFile(path, {}, function (e) {0
      //   alert('打开文件失败' + JSON.stringify(e, null, 4))
      // })
      self.Audio2dataURL(fileSaveUrl)
    } else { //下载失败
      Toast({
        message: 'pdf下载失败',
        position: 'bottom',
        duration: 3000
      });
    }
  });
  dtask.start();
}

Vue.prototype.Audio2dataURL = function (path) {
  const self = this
  plus.io.resolveLocalFileSystemURL(path, function (entry) {
    entry.file(function (file) {
      var reader = new plus.io.FileReader();
      reader.onloadend = function (e) {
        console.log(e.target.result);
        wakeUpJingJiangAppPrint(e.target.result)
      };
      reader.readAsDataURL(file);
    }, function (e) {
      Toast({
        message: '读写出现异常' + e.message,
        position: 'bottom',
        duration: 3000
      });
    })
  })
}

/**
 * money 金额
 * dis 显示方式  k,w
 * bs 是否开头
 * bstart 单位值
 */
Vue.prototype.$formatMoney = function (money, dis, bs, bstart, dataDisplayK, noDisplayW, noCount) {
  if (!money) {
    money = 0;
  }
  let language = this.$getLanguage();
  let ret = 0;
  let d = '';

  if (localStorage.getItem('dataDisplayW') == 'yes') { // 为某家酒店特殊添加
    if(noCount == 'yes'){
      ret = money
      d = ''
    } else {
      ret = (money / 10000).toFixed(2);
      if(noDisplayW == 'yes'){
        d = ''
      } else {
        d = this.$t('tenThousand');
      }
    }
  } else {
    if (dataDisplayK) {
      if (money == 0) {
        ret = money;
        d = '';
      } else {
        ret = (money / 1000).toFixed(2);
        d = 'K';
      }
    } else {
      if (dis == 'k' || language == 'en_US') {
        if (money >= 1000000) {
          ret = (money / 1000000).toFixed(2);
          d = 'M';
        } else if (money >= 1000) {
          ret = (money / 1000).toFixed(2);
          d = 'K';
        } else {
          ret = money;
        }
      } else {
        if (money >= 100000000) {
          ret = (money / 100000000).toFixed(2);
          d = this.$t('hundredmillion');
        } else if (money >= 10000) {
          ret = (money / 10000).toFixed(2);
          d = this.$t('tenThousand');
        } else {
          ret = money;
        }
      }
    }
  }
  return ((bstart && bs) ? '<small>' + bstart + '</small>' : '') + ret + ((bs && d) ? ' <small>' + d + '</small>' : (d ? d : ''));
}

getUserPermission();

function getUserPermission() {
  axios.post('/mobilepmsapi/sysOptions/findUserAuth', {noErrorToast: true})
    .then(res => {
      if (res.data.result == 0) {
        var permissionList = res.data.retVal || []
        localStorage.setItem('mihotelNewPermission', JSON.stringify(permissionList))
      } else {
        // this.msg2(res.data.msg);
      }
    });
}

Vue.prototype.$hasPermission = function (permission, oldHasPermission) {
  var useMhPermission = localStorage.getItem('useMhPermission') == 'yes'
  // 没有启用就无论如何都返回老权限
  if (useMhPermission) {
    var newListStr = localStorage.getItem('mihotelNewPermission') || '[]'
    var permissionArr = []
    try {
      permissionArr = JSON.parse(newListStr)
    } catch (ex) {
      permissionArr = []
    }
    // console.log('是否启用新权限: ', useMhPermission, '新权限列表: ', permissionArr)
    var hasPermission = false
    if (useMhPermission && (permissionArr.length > 0)) {
      if (permissionArr.indexOf(permission) > -1) {
        hasPermission = true
      }
    }
    return hasPermission
  } else {
    return oldHasPermission
  }
}

echarts.registerTheme('customed', echartsTheme);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js